import { View } from 'react-native';

import { Text } from '@squire/ui';

import { styles } from './styles';
import type { ServiceGroupHeadingProps } from './types';

export function ServiceGroupHeading({
  name,
  testID,
}: ServiceGroupHeadingProps) {
  return (
    <View
      accessible
      accessibilityRole="header"
      style={styles.container}
      testID={testID}
    >
      <Text variant="sStrong" color="textSecondary">
        {name}
      </Text>
    </View>
  );
}

ServiceGroupHeading.displayName = 'ServiceGroupHeading';
